import React from 'react';
import PropTypes from 'prop-types';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import { Select, Modal, message } from 'antd';
import { hashHistory } from 'react-router'

const Option = Select.Option;

export default class ArchiveProcessClassDetailPage extends React.Component {
  static propTypes = {
  };

  constructor(props) {
    super(props);
    let currentSemester = SharedTools.getCurrentSemester();
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      schoolId: this.props.params.schoolId,
      classId: this.props.params.classId,
      semester: props.location.query.semester ? props.location.query.semester : currentSemester,
      className: props.location.query.className ? props.location.query.className : '',
      ratio: 0,
      currentSemester,
      semesters: [],
      statisticTemplates: []
    };
  }

  componentDidMount() {
    DataService.getSchoolInfo(this.state.schoolId).then((school) => {
      let currentSemester = this.state.currentSemester;
      if (school && school.archive_semester_count == 1) {
        let year = currentSemester.toString().split('').slice(0, 4).join('');
        currentSemester = Number(year + '1');
      }
      let semesters = SharedTools.getAllSemesters(currentSemester, 20201, school.archive_semester_count)

      this.setState({
        semesters,
        currentSemester
      })

      this.getClassArchiveStatistics()

    }).catch((error) => {
      console.log(error);
    });
  }

  getClassArchiveStatistics() {
    let data = {
      semester: this.state.semester,
      class_record_id: this.state.classId
    }
    DataService.getClassArchiveStatistics(data).then(res => {
      this.setState({
        statisticTemplates: res.statistic_templates,
        ratio: res.ratio
      })
    }).catch((error) => {
      message.error('获取失败');
    })
  }

  goPageDetail(id) {
    let { semester, schoolId, classId } = this.state;
    hashHistory.push(`archive/archive-process/schools/${schoolId}/classes/${classId}/process-detail?semester=${semester}&id=${id}`);
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.getClassArchiveStatistics();
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  toolProcessDetail(process) {
    if (!process) {
      return 0
    }

    let str = (process * 100).toFixed(2).toString()

    return str.slice(0, str.length - 1) + '%'
  }

  toolsTemplateTitle(templates) {
    let str = templates.map(t => {
      return t.page_title ? t.page_title : t.title
    }).join(',')
    return str
  }

  render() {
    let { statisticTemplates, ratio, className } = this.state;
    return (
      <div className="archive-process-class-detail-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        <div className="page-header">
          {className} <span className="header-label">档案完成进度 - {this.toolProcessDetail(ratio)}</span>
        </div>
        <div className="process-list">
          <div className="process-item process-header">
            <div>模板</div>
            <div>已配置/应配置</div>
            <div>完成情况</div>
            <div className="page-detail">已配置模板</div>
          </div>
          {statisticTemplates.map(item => <div className="process-item process-detail" onClick={this.goPageDetail.bind(this, item.id)} key={item.id}>
            <div>{item.title}</div>
            <div>{item.config_count}/{item.target_value}</div>
            <div>{this.toolProcessDetail(item.ratio)}</div>
            <div className="page-detail">{this.toolsTemplateTitle(item.templates_info)}</div>
          </div>)}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/process/ArchiveProcessClassDetailPage.jsx